<template>
  <div class="modal-header">
    <h5 class="modal-title" id="exampleModalLabel">Trip Details</h5>
    <button
      ref="modalCloseBtn"
      type="button"
      class="btn-close"
      data-bs-dismiss="modal"
      aria-label="Close"
    >
      <i class="bi bi-x-circle"></i>
    </button>
  </div>
  <div class="modal-body">
    <h2 style="font-size: 20px; font-weight: 600; line-height: 32px">
      {{ partnerList.driver_name }}
    </h2>
    <h4 style="font-size: 16px; font-weight: 500; line-height: 14px">
      CD:
      <template v-for="(trCode, index) in trCodes" :key="index">
        <span v-if="index">, </span>
        <a
          target="_blank"
          :href="
            '/trip-request/vehicle-request/details/' + trCode.trip_request_id
          "
          >{{ trCode.trip_code }}</a
        >
      </template>
    </h4>
    <h4 style="font-size: 16px; font-weight: 500; line-height: 20px">
      Company Codes: {{ partnerList.all_company_codes }}
    </h4>
    <h4
      class="mt-4"
      style="font-size: 16px; font-weight: 500; line-height: 14px; margin: 0"
    >
      Number of Trips:
      <b style="font-weight: 700">{{ totalNumberOfTrips }}</b>
    </h4>

    <div class="nav nav-tabs partner-nav mt-5">
      <button
        :class="{ 'nav-link': true, active: selectedTabIndex === 'summary' }"
        @click="selectedTabIndex = 'summary'"
      >
        Summary
      </button>
      <template v-for="(route, index) in route_attendance_list" :key="index">
        <button
          :class="{ 'nav-link': true, active: selectedTabIndex === index }"
          @click="
            selectedTabIndex = index;
            getUserRouteWiseAttendance(route.route_id);
          "
        >
          {{ route.route_name }}
        </button>
      </template>
    </div>

    <div class="row">
      <div class="col-sm-12">
        <div class="tab-details">
          <DefaultLoader v-if="isLoading"></DefaultLoader>
          <div
            class="summary-tab table-responsive"
            v-else-if="selectedTabIndex === 'summary'"
          >
            <table class="table">
              <thead>
                <tr>
                  <th>Route Name</th>
                  <th>Company Name</th>
                  <th>Body Rent</th>
                  <th>Total KM</th>
                  <th>Total Lunch Allowance</th>
                  <th>Total OT</th>
                  <th>Others</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(attendance, index) in route_attendance_list"
                  :key="index"
                >
                  <td>
                    <span
                      class="route-text"
                      @click="
                        selectedTabIndex = index;
                        getUserRouteWiseAttendance(attendance.route_id);
                      "
                      >{{
                        attendance.route_name ? attendance.route_name : 'N/A'
                      }}</span
                    >
                  </td>
                  <td>
                    {{
                      attendance.company_code ? attendance.company_code : 'N/A'
                    }}
                  </td>
                  <td>
                    {{
                      attendance.body_rent
                        ? attendance.body_rent + ' TK'
                        : 'N/A'
                    }}
                  </td>
                  <td>
                    {{
                      attendance.total_km ? attendance.total_km + ' KM' : 'N/A'
                    }}
                  </td>
                  <td>
                    {{
                      attendance.lunch_allowance
                        ? attendance.lunch_allowance + ' TK'
                        : 'N/A'
                    }}
                  </td>
                  <td>
                    {{
                      attendance.over_time_hours
                        ? attendance.over_time_hours + ' hours'
                        : 'N/A'
                    }}
                  </td>
                  <td>
                    {{
                      attendance.other_payments
                        ? attendance.other_payments + ' TK'
                        : 'N/A'
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div
            class="route-tab"
            v-else-if="helpers.isNumeric(selectedTabIndex)"
          >
            <template v-if="Object.keys(routeWisePerDayAttendance).length > 0">
              <div class="partner-modal-section">
                <div class="partner-modal-info fixed-height-info">
                  <div class="info-content">
                    <template
                      v-for="(attendances, key) in routeWisePerDayAttendance"
                      :key="key"
                    >
                      <div
                        class="info-row"
                        v-for="(attendance, index) in attendances"
                        :key="index"
                      >
                        <p class="item-date">
                          {{
                            $format.date(
                              attendance.trip_start_date,
                              'ddd, DD-MM-YYYY'
                            )
                          }}
                        </p>
                        <div class="row info-item-row">
                          <div class="col-sm-3">
                            <div>
                              <h5 class="info-title">KM</h5>
                              <p class="item-info">
                                {{
                                  attendance.total_km
                                    ? attendance.total_km + ' KM'
                                    : 'N/A'
                                }}
                              </p>
                            </div>
                          </div>
                          <div class="col-sm-3">
                            <div>
                              <h5 class="info-title">Over Time</h5>
                              <p class="item-info">
                                {{
                                  attendance.over_time_hours
                                    ? attendance.over_time_hours + ' hours'
                                    : 'N/A'
                                }}
                              </p>
                            </div>
                          </div>
                          <div class="col-sm-3">
                            <div>
                              <h5 class="info-title">Lunch</h5>
                              <p class="item-info">
                                {{
                                  attendance.lunch_allowance_per_day
                                    ? attendance.lunch_allowance_per_day + ' TK'
                                    : 'N/A'
                                }}
                              </p>
                            </div>
                          </div>
                          <div class="col-sm-3">
                            <div>
                              <h5 class="info-title">Others</h5>
                              <p class="item-info">
                                {{
                                  attendance.other_payments
                                    ? attendance.other_payments + ' TK'
                                    : 'N/A'
                                }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </template>
            <div class="alert alert-danger text-center" v-else>
              No Attendance Information found!
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-cancel"
      data-bs-dismiss="modal"
      aria-label="Close"
    >
      Close
    </button>
    <button
      v-if="
        partnerList.total === partnerList.ConfirmedCount &&
        partnerList.total > 0
      "
      class="btn btn-primary"
      disabled
    >
      Bill Generated
    </button>
    <button
      v-else-if="isLoadingGenerateBill"
      class="btn btn-primary"
      type="button"
      disabled
    >
      <span
        class="spinner-border spinner-border-sm"
        role="status"
        aria-hidden="true"
      ></span>
      Loading...
    </button>
    <button
      v-else
      class="btn btn-primary"
      @click="generateBill()"
      :disabled="
        !(
          totalNumberOfTrips &&
          totalNumberOfVerifiedTrips &&
          totalNumberOfTrips === totalNumberOfVerifiedTrips
        )
      "
    >
      Generate Bill
    </button>
  </div>
</template>

<script>
import http from '../../config/axios';
import helpers from '../../store/helpers';

export default {
  props: ['partnerList', 'date', 'tzoffset'],
  data() {
    return {
      isLoading: false,
      isLoadingGenerateBill: false,
      route_attendance_list: [],
      trWiseAttendanceSummary: {},
      routeWisePerDayAttendance: {},
      selectedTabIndex: 'summary',
      helpers
    };
  },
  watch: {
    partnerList: {
      handler: function () {
        this.getUserWiseAttendanceSummary();
      },
      deep: true
    }
  },
  computed: {
    trCodes() {
      let uniqueTRCodes = [];
      let trCodes = [];

      let tripCodes = this.partnerList.all_trip_codes
        ? this.partnerList.all_trip_codes.split(',')
        : [];
      let tripIds = this.partnerList.trip_request_id
        ? this.partnerList.trip_request_id.split(',')
        : [];

      tripCodes.forEach((tripCode, index) => {
        if (!uniqueTRCodes.includes(tripCode)) {
          uniqueTRCodes.push(tripCode);
          trCodes.push({
            trip_code: tripCode,
            user_code: this.partnerList.user_code,
            trip_request_id: tripIds[index]
          });
        }
      });

      return trCodes;
    },
    totalNumberOfTrips() {
      let total = 0;

      for (const key in this.trWiseAttendanceSummary) {
        if (helpers.isNumeric(this.trWiseAttendanceSummary[key].total)) {
          total += Number(this.trWiseAttendanceSummary[key].total);
        }
      }

      return total;
    },
    totalNumberOfVerifiedTrips() {
      let total = 0;

      for (const key in this.trWiseAttendanceSummary) {
        if (
          helpers.isNumeric(this.trWiseAttendanceSummary[key].VerifiedCount)
        ) {
          total += Number(this.trWiseAttendanceSummary[key].VerifiedCount);
        }
      }

      return total;
    },
    startDate() {
      let date = null;
      if (this.date && this.date[0] && this.tzoffset) {
        date = new Date(this.date[0] - this.tzoffset)
          .toISOString()
          .substring(0, 10);
      }
      return date;
    },
    endDate() {
      let date = null;
      if (this.date && this.date[1] && this.tzoffset) {
        date = new Date(this.date[1] - this.tzoffset)
          .toISOString()
          .substring(0, 10);
      }
      return date;
    }
  },
  methods: {
    getUserWiseAttendanceSummary() {
      this.selectedTabIndex = 'summary';
      this.isLoading = true;
      http
        .get(
          `/v2/partners/attendance/route/${this.partnerList.user_code}?start_date=${this.startDate}&end_date=${this.endDate}&modality=${this.partnerList.modality}&serviceType=${this.partnerList.service_type}`
        )
        .then((response) => {
          this.isLoading = false;
          if (response.status === 200) {
            this.route_attendance_list = response.data.data.route_wise_data;
            this.trWiseAttendanceSummary = response.data.data.summary;
          }
        })
        .catch((error) => {
          this.isLoading = false;
          this.$partnerSwal.errorToast.fire({
            title: 'Error!',
            text: error.response.data?.message
          });
        });
    },
    getUserRouteWiseAttendance(route_id) {
      this.isLoading = true;
      http
        .get(
          `/v2/partners/attendance/trip-start-date/${route_id}/${this.partnerList.user_code}?start_date=${this.startDate}&end_date=${this.endDate}&modality=${this.partnerList.modality}&serviceType=${this.partnerList.service_type}`
        )
        .then((response) => {
          this.isLoading = false;
          if (response.status === 200) {
            this.routeWisePerDayAttendance = response.data.data;
          }
        })
        .catch((error) => {
          this.isLoading = false;
          this.$partnerSwal.errorToast.fire({
            title: 'Error!',
            text: error.response.data?.message
          });
        });
    },
    getAllTripRequestIds() {
      let ids = [];
      if (this.trWiseAttendanceSummary) {
        for (const key in this.trWiseAttendanceSummary) {
          if (this.trWiseAttendanceSummary[key]?.trip_request_id) {
            ids.push(this.trWiseAttendanceSummary[key].trip_request_id);
          }
        }
      }
      return ids;
    },
    generateBill() {
      let tripRequestIds = this.getAllTripRequestIds();
      this.isLoadingGenerateBill = true;
      http
        .patch(`v2/partners/attendance/verification_status`, {
          start_date: this.startDate,
          end_date: this.endDate,
          user_code: this.partnerList.user_code,
          modality: this.partnerList.modality,
          service_type: this.partnerList.service_type,
          trip_requests: tripRequestIds
        })
        .then((response) => {
          this.isLoadingGenerateBill = false;
          if (response.status === 200) {
            console.log(response.data.data);

            this.$emit('getDriverList');
            this.$partnerSwal.quickSuccessAlert.fire({
              title: 'Success!',
              text: response.data?.message
            });
            this.$refs.modalCloseBtn.click();
          }
        })
        .catch((error) => {
          this.isLoadingGenerateBill = false;
          this.$partnerSwal.errorToast.fire({
            title: 'Error!',
            text: error.response.data?.message
          });
        });
    }
  }
};
</script>

<style scoped>
.partner-nav {
  width: 100%;
}
.tab-details {
  margin-top: 18px;
}
.summary-tab {
  background: rgba(255, 255, 255, 0.1);
  box-shadow: 0px 4px 5px rgba(0, 0, 0, 0.07);
  border-radius: 4px 4px 0px 0px;
}
table {
  margin-bottom: 0;
}
table thead {
  background-color: #f3f3f3;
}
table tbody {
  border-top: none !important;
}
table thead tr th {
  font-size: 12px;
  font-weight: 500;
  padding: 10px 12px;
}
table tbody tr td {
  font-size: 12px;
  font-weight: 400;
  padding: 12px 12px;
}
.route-text {
  cursor: pointer;
}
.route-text:hover {
  color: #652f8f;
}
.info-item-row {
  margin-left: 2px;
}
.fixed-height-info {
  max-height: 350px;
}
.partner-modal-info .info-row {
  padding: 8px 0;
  color: #121212;
}
.partner-modal-info .info-row:first-child {
  padding-top: 0;
}
.partner-modal-info .info-row:last-child {
  padding-bottom: 0;
}
.partner-modal-info .info-row h5 {
  margin-bottom: 4px;
  font-weight: 600;
  font-size: 14px;
  line-height: 16px;
}
.partner-modal-info .info-row .item-info {
  margin-bottom: 0;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
}
.alert {
  margin-bottom: 0;
}
</style>
